module.exports = __webpack_public_path__ + "static/media/ajout-participant.09d0353a.png";